import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '@env/environment';

const base_url = environment.BASE_URL;

@Injectable({
  providedIn: 'root',
})
export class UserHttpService {
  constructor(private httpClient: HttpClient) {}

  public fetchAll(): Observable<any> {
    return this.httpClient.get(`${base_url}api/users-list`);
  }

  public fetchAccessLevels(): Observable<any> {
    return this.httpClient.get(`${base_url}api/access-levels`);
  }

  public addUser(data): Observable<any> {
    return this.httpClient.post(`${base_url}api/users`, data);
  }

  public updateUser(id, data): Observable<any> {
    return this.httpClient.patch(`${base_url}api/users/${id}`, data);
  }

  public updateStatus(data): Observable<any> {
    return this.httpClient.post(`${base_url}admin/user/update-status`, data);
  }
}
